<template>
  <v-container>
    <v-card cols="12" elevation="0">
      <v-col>
        <v-row id="start">
          <v-card-title>
            <v-img :max-width="50" class="mr-3 rcorners whiteBackground" :src="currentItem.icon"></v-img>
            <span class="title font-weight-light">{{currentItem.title}}</span>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <ShareNetwork
              class="mx-1"
              network="facebook"
              :url="currentURL"
              :title="currentItem.title"
              :description="currentItem.slogan"
              :quote="currentItem.title"
              :hashtags="currentItem.keyWords"
            >
              <v-icon>mdi-facebook</v-icon>
            </ShareNetwork>

            <ShareNetwork
              class="mx-1"
              network="vk"
              :url="currentURL"
              :title="currentItem.title"
              :description="currentItem.slogan"
              :quote="currentItem.title"
              :hashtags="currentItem.keyWords"
            >
              <v-icon>mdi-vk</v-icon>
            </ShareNetwork>

            <ShareNetwork
              class="mx-1"
              network="twitter"
              :url="currentURL"
              :title="currentItem.title"
              :description="currentItem.slogan"
              :quote="currentItem.title"
              :hashtags="currentItem.keyWords"
            >
              <v-icon>mdi-twitter</v-icon>
            </ShareNetwork>
          </v-card-actions>

          <v-card-text class="headline font-weight-bold">{{currentItem.slogan}}</v-card-text>

          <v-card-text v-if="currentItem.youtube" class="headline font-weight-bold" align="center">
            <div class="rounded" :style="getStyle(currentItem)">
              <youtube
                :player-width="getSize(currentItem).width"
                :player-height="getSize(currentItem).height"
                :player-vars="{autoplay: 1}"
                :video-id="getIdFromURL(currentItem.youtube)"
              ></youtube>
            </div>
          </v-card-text>

          <v-card-text class="font-weight-regular" v-html="currentItem.description"></v-card-text>

          <v-divider></v-divider>
        </v-row>
        <v-row fluid>
          <v-container>
            <vue-horizontal-list :items="currentItem.screens" :options="getOptions(currentItem)">
              <template v-slot:default="{item}">
                <v-card max-width="400" @click="clickOnScreen(item)">
                  <v-img :src="item" :lazy-src="item" class="lighten-2">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </template>
            </vue-horizontal-list>
          </v-container>
        </v-row>
      </v-col>
      <v-col v-if="currentItem.privacy" class="text-center">
        <v-btn
          :href="currentItem.privacy"
          target="_blank"
          class="ma-2"
          text
          small
        >{{this.$vuetify.lang.translator("detail.privacyPolicy")}}</v-btn>
      </v-col>
      <v-col v-if="currentItem.terms" class="text-center">
        <v-btn
          :href="currentItem.terms"
          target="_blank"
          class="ma-2"
          text
          small
        >{{this.$vuetify.lang.translator("detail.terms")}}</v-btn>
      </v-col>
    </v-card>
    <v-overlay v-if="currentItem.screens" :value="overlay" @click.self="overlay = false">
      <v-col width="100%" class="mr-10" elevation="0">
        <v-row>
          <v-spacer></v-spacer>
          <v-btn icon @click="overlay = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-row>
          <div :style="`width:${windowWidth - 100}px;`">
            <v-carousel
              v-model="currentScreenIndex"
              cycle
              hide-delimiter-background
              show-arrows-on-hover
              :height="windowHeight - 200"
            >
              <v-carousel-item v-for="(screen, i) in currentItem.screens" :key="i">
                <v-sheet color="transparent" tile>
                  <v-row class="fill-height" align="center" justify="center">
                    <v-img :max-height="windowHeight - 200" :src="screen" aspect-ratio="1" contain></v-img>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-row>
      </v-col>
    </v-overlay>
  </v-container>
</template>

<script>
import VueHorizontalList from "./vue-horizontal-list.vue";
import { eventEmitter } from "../main";
import { getIdFromURL } from "vue-youtube-embed";

export default {
  components: {
    vueHorizontalList: VueHorizontalList,
  },
  data() {
    return {
      currentScreenIndex: 0,
      overlay: false,
      name: this.$router.currentRoute.params["id"],
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      currentScreenOnOverlay: null,
      options: {
        responsive: [
          { end: 300, size: 1 },
          { start: 300, end: 400, size: 2 },
          { start: 400, end: 576, size: 3 },
          { start: 576, end: 768, size: 4 },
          { start: 768, end: 992, size: 5 },
          { size: 5 },
        ],
        list: {
          windowed: 600,
          padding: 0,
        },
        navigation: {
          start: 600,
          color: "#000",
        },
      },
      optionsForWideScreens: {
        responsive: [
          { end: 300, size: 1 },
          { start: 300, end: 400, size: 1 },
          { start: 400, end: 576, size: 2 },
          { start: 576, end: 768, size: 2 },
          { start: 768, end: 992, size: 3 },
          { size: 3 },
        ],
        list: {
          windowed: 600,
          padding: 50,
        },
        navigation: {
          start: 600,
          color: "#000",
        },
      },
    };
  },
  watch: {
    // windowWidth(newWidth, oldWidth) {
    //   console.log(`it changed to ${newWidth} from ${oldWidth}`);
    // },
  },
  computed: {
    getOverlayWidth() {
      return this.windowWidth - 30;
    },
    currentURL() {
      return "https://file.ilook.su" + this.$router.currentRoute.fullPath;
    },
    currentItem() {
      return this.$store.getters.getCurrentItem;
    },
  },
  methods: {
    clickOnScreen(item) {
      if (this.windowWidth < 600) {
        return;
      }
      this.currentScreenIndex = this.currentItem.screens.indexOf(item);
      this.overlay = !this.overlay;
    },
    getOptions(item) {
      if (item.isWideScreens) {
        return this.optionsForWideScreens;
      } else {
        return this.options;
      }
    },
    wideFrameSize(item) {
      if (this.windowWidth <= 600) {
        return {
          width: item.frameWidth / 7,
          height: item.frameHeight / 7,
        };
      } else {
        return {
          width: item.frameWidth / 4,
          height: item.frameHeight / 4,
        };
      }
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    },
    isWide(item) {
      return item.frameWidth > item.frameHeight;
    },
    getSize(item) {
      if (this.isWide(item)) {
        return {
          width: this.wideFrameSize(item).width,
          height: this.wideFrameSize(item).height,
        };
      } else {
        return {
          width: item.frameWidth,
          height: item.frameHeight,
        };
      }
    },
    getStyle(item) {
      if (this.isWide(item)) {
        return `width: ${this.wideFrameSize(item).width}px; height: ${
          this.wideFrameSize(item).height
        }px;`;
      } else {
        return `width: ${item.frameWidth}px; height: ${item.frameHeight}px;`;
      }
    },
    getIdFromURL(url) {
      if (url) {
        return getIdFromURL(url);
      } else {
        return null;
      }
    },
    update() {
      console.log("UPDATE FOR :>> ", this.name);
      this.$store.dispatch("updateCurrentAction", {
        lang: this.$vuetify.lang.current,
        name: this.name,
      });
    },
    updateTitle() {
      if (this.currentItem.title) {
        document.title = this.currentItem.title;
      } else {
        setTimeout(() => {
          this.updateTitle();
        }, 1000);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateTitle();
      window.addEventListener("resize", this.onResize);
    });
    this.update();
    let sheet = document.getElementById("scrolling_sheet");
    if (sheet) {
      sheet.scroll(0, 0);
    }
  },
  created() {
    eventEmitter.$on("updateLocale", this.update);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    eventEmitter.$off("updateLocale", this.update);
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    if (to.hash == "#scrollOnTop") {
      this.$store.commit("resetStoredPosition");
      next(to.path);
      return;
    }

    next();
  },
};
</script>


<style scoped>
.whiteBackground {
  background-color: #fff;
}

.rounded {
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}
</style>
